/**
 * Default meta tag configuration for the application
 * This file contains default values for meta tags used across the application
 */

const defaultMetaConfig = {
  // Default site-wide meta tags
  defaults: {
    title: 'RPC - ניטור והדברה חכמה',
    description: 'פתרונות ניטור והדברה חכמה ומקצועית',
    image: 'https://main--rpc-tech.netlify.app/og-image.jpg',
    url: 'https://main--rpc-tech.netlify.app',
    type: 'website', // website, article, product, etc.
    locale: 'he_IL',
    twitterCard: 'summary_large_image',
    siteName: 'RPC',
  },
  
  // Page-specific meta configurations that override defaults
  pages: {
    home: {
      title: 'RPC - ניטור והדברה חכמה',
      description: 'פתרונות ניטור והדברה חכמה ומקצועית',
    },
    form: {
      title: 'RPC רישום לקוח חדש',
      description: 'אנא מזמינים אתכם למלא את פרטיכם כדי שנוכל לחזור אליכם במהרה ונתחיל לעבוד יחד',
      url: 'https://main--rpc-tech.netlify.app/form',
    },
    'group-purchase': {
      title: 'הצטרפות לקבוצת רכישה - מאסטר פליי | RPC',
      description: 'הצטרפו לקבוצת רכישה של מאסטר פליי במחיר 295 ₪ במקום 390 ₪. חסכון של 24%!',
      image: 'https://firebasestorage.googleapis.com/v0/b/rpc-leads.appspot.com/o/WhatsApp%20Image%202025-03-09%20at%2019.29.48_7ede853a.jpg?alt=media&token=1c000a5f-791c-4984-9e54-e7365cc16194',
    },
    knowledge: {
      title: 'ידע מקצועי | RPC',
      description: 'מאגר ידע מקצועי בתחום ניטור והדברת מזיקים',
    },
    pests: {
      title: 'מגדיר מזיקים | RPC',
      description: 'מגדיר מזיקים מקצועי לזיהוי מזיקים ודרכי הטיפול בהם',
    },
    productInfo: {
      title: 'מידע על מוצרים | RPC',
      description: 'מידע על מוצרים ומסמכים נלווים - RPC',
    },
    orderWizard: {
      title: 'הזמנת מוצרים | RPC',
      description: 'הזמינו מוצרים ישירות באתר RPC',
    },
  }
};

export default defaultMetaConfig;